import { Paper, Stack } from '@mui/material'
import { isEmpty } from 'lodash'

import ChatNow from '~/features/chatbot/components/linkView/intro/chatNow'
import Item from '~/features/chatbot/components/linkView/intro/item'
import SocialLinks from '~/features/chatbot/components/socialLinks'
import { partializeLinks } from '~/features/chatbot/components/socialLinks/utils'
import useGetElementDimensions from '~/features/ui/hooks/useGetElementDimensions'
import useIdentifyViewportWidth from '~/features/ui/hooks/useIdentifyViewportWidth'
import EElement from '~/features/ui/models'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  chatNowHandler: () => void
}

function Intro({ chatNowHandler }: TProps) {
  const agent = store((state) => state.chatbot.agent)
  const { height: layoutFooterHeight } = useGetElementDimensions(
    EElement.chatbotFooter,
  )
  const { height: headerHeight } = useGetElementDimensions(
    EElement.chatbotHeader,
  )
  const { isExtraSmallScreen, isSmallScreen } = useIdentifyViewportWidth()
  const [socialLinks, agentLinks] = partializeLinks(agent.customLinks ?? [])
  return (
    <Paper
      gap={3}
      component={Stack}
      elevation={3}
      sx={{
        paddingBlock: 2,
        borderRadius: 4,
        mt: 2,
        marginInline: 2,
        height: 'fit-content',
        overflow: 'hidden',
      }}
    >
      <Stack
        gap={2}
        sx={{
          alignItems: { xxxs: 'stretch', md: 'center' },
          paddingInline: { xxxs: 2, xs: 8, sm: 16, md: 0 },
          height: '100%',
          ...(isExtraSmallScreen || isSmallScreen
            ? {
                maxHeight: {
                  xxxs: `calc(100vh - ${rem(headerHeight)} - ${rem(layoutFooterHeight)} - ${rem(180)})`,
                  sm: '100%',
                },
                minHeight: {
                  xxxs: `calc(100vh - ${rem(headerHeight)} - ${rem(layoutFooterHeight)} - ${rem(180)})`,
                  sm: '100%',
                },
              }
            : {}),
        }}
      >
        <ChatNow chatNowHandler={chatNowHandler} />
        {!isEmpty(agentLinks) && (
          <Stack
            gap={2}
            sx={{
              overflowY: 'auto',
              overflowX: 'hidden',
              paddingBlock: 2,
              paddingRight: rem(4),
            }}
          >
            {agentLinks.map((item) => (
              <Item key={item.label} {...item} />
            ))}
          </Stack>
        )}
      </Stack>
      {!isEmpty(socialLinks) && <SocialLinks links={socialLinks} />}
    </Paper>
  )
}

export default Intro
